module.exports = __webpack_public_path__ + "static/media/top-user-banner-1.9edc69c9.jpg";